module.exports = __webpack_public_path__ + "static/img/profile.0bff8b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/mobile/profile.jpg
// module id = 332
// module chunks = 64